export default __webpack_public_path__ + "static/media/positivesum.030b7e3b.svg";